import { useAppShortcut } from '@/features/shortcuts';
import { settingsStore, TypeScale } from '@/stores/settings.store';

export function useTypeScaleHotkeys() {
  const hotkeysOptions = {
    preventDefault: true,
    enableOnContentEditable: true,
    enableOnFormTags: true,
  };

  useAppShortcut(
    'typeScale.reset',
    () => settingsStore.setTypeScale(TypeScale.Normal),
    hotkeysOptions
  );

  useAppShortcut(
    'typeScale.increase',
    () => {
      const scales = Object.values(TypeScale);

      const currentIndex = scales.findIndex(
        (scale) => scale === settingsStore.typeScale
      );

      if (currentIndex === -1) {
        settingsStore.setTypeScale(TypeScale.Normal);

        return;
      }

      if (scales.length - 1 === currentIndex) return;

      settingsStore.setTypeScale(scales[currentIndex + 1]);
    },
    hotkeysOptions
  );

  useAppShortcut(
    'typeScale.decrease',
    () => {
      const scales = Object.values(TypeScale);

      const currentIndex = scales.findIndex(
        (scale) => scale === settingsStore.typeScale
      );

      if (currentIndex === -1) {
        settingsStore.setTypeScale(TypeScale.Normal);

        return;
      }

      if (currentIndex === 0) return;

      settingsStore.setTypeScale(scales[currentIndex - 1]);
    },
    hotkeysOptions
  );
}
